import ScheduledWhatsappMessagesAPI from 'dashboard/api/saas/scheduledWhatsappMessages';

const state = {
  recordsByConversation: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const recordsForConversation = ($state, conversationId) =>
  $state.recordsByConversation[conversationId] || [];

const getters = {
  getByConversation: $state => conversationId =>
    recordsForConversation($state, conversationId),
  getPendingCount: $state => conversationId =>
    recordsForConversation($state, conversationId).filter(
      message => message.status === 'pending'
    ).length,
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit }, { conversationId }) {
    commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isFetching: true });
    try {
      const response = await ScheduledWhatsappMessagesAPI.list(conversationId);
      commit('SET_SCHEDULED_WHATSAPP_MESSAGES', {
        conversationId,
        records: response.data || [],
      });
      return response.data;
    } finally {
      commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, data) {
    commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isCreating: true });
    try {
      const response = await ScheduledWhatsappMessagesAPI.create(data);
      commit('UPSERT_SCHEDULED_WHATSAPP_MESSAGE', {
        conversationId: data.conversationId,
        record: response.data,
      });
      return response.data;
    } finally {
      commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, data) {
    commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isUpdating: true });
    try {
      const response = await ScheduledWhatsappMessagesAPI.update(data);
      commit('UPSERT_SCHEDULED_WHATSAPP_MESSAGE', {
        conversationId: data.conversationId,
        record: response.data,
      });
      return response.data;
    } finally {
      commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, data) {
    commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isDeleting: true });
    try {
      await ScheduledWhatsappMessagesAPI.delete(data);
      commit('MARK_SCHEDULED_WHATSAPP_MESSAGE_CANCELLED', data);
    } finally {
      commit('SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_SCHEDULED_WHATSAPP_MESSAGES_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_SCHEDULED_WHATSAPP_MESSAGES($state, { conversationId, records }) {
    $state.recordsByConversation = {
      ...$state.recordsByConversation,
      [conversationId]: records,
    };
  },
  UPSERT_SCHEDULED_WHATSAPP_MESSAGE($state, { conversationId, record }) {
    const records = recordsForConversation($state, conversationId);
    const index = records.findIndex(message => message.id === record.id);
    const nextRecords =
      index === -1
        ? [record, ...records]
        : records.map(message => (message.id === record.id ? record : message));

    $state.recordsByConversation = {
      ...$state.recordsByConversation,
      [conversationId]: nextRecords,
    };
  },
  MARK_SCHEDULED_WHATSAPP_MESSAGE_CANCELLED($state, { conversationId, id }) {
    const records = recordsForConversation($state, conversationId).map(
      message =>
        message.id === id
          ? {
              ...message,
              status: 'cancelled',
              cancelled_at: Math.floor(Date.now() / 1000),
            }
          : message
    );

    $state.recordsByConversation = {
      ...$state.recordsByConversation,
      [conversationId]: records,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
